module.exports = __webpack_public_path__ + "assets/img/106301.5474c131.png";